import { usePage } from '@inertiajs/react'
import useLocalizedValue from '@/hooks/use-localized-value'
import { VipCardSection, type VipCardHeader } from '@/Components/vip-card/vip-card-section'
import type { Partner, PartnerType } from '@/lib/vip-card'
import type { Bundle, PageProps, Translatable } from '@/types'

interface HeaderContent {
  eyebrow: Translatable<string>
  title: Translatable<string>
  description: Translatable<string>
  benefits: {
    title: Translatable<string>
    description: Translatable<string>
    icon: string | null
  }[]
}

type VipCardPageProps = PageProps & {
  header: HeaderContent
  partners: Partner[]
  types: PartnerType[]
  offers: Bundle[]
}

export default function VipCard() {
  const { header, partners, types, offers } = usePage<VipCardPageProps>().props

  return (
    <div className="vip-theme contents">
      {/* The design sits this page on a tint, which is what lets the white cards read. */}
      <div aria-hidden className="fixed inset-0 -z-10 bg-background" />

      <VipCardSection
        partners={partners ?? []}
        types={types ?? []}
        offers={offers ?? []}
        header={useLocalizedHeader(header)}
      />
    </div>
  )
}

/** The panel writes the header in three languages; this picks the viewer's. */
function useLocalizedHeader(header: HeaderContent): VipCardHeader {
  return {
    eyebrow: useLocalizedValue(header?.eyebrow) ?? '',
    title: useLocalizedValue(header?.title) ?? '',
    description: useLocalizedValue(header?.description) ?? '',
    benefits: (header?.benefits ?? []).map((benefit) => ({
      title: useLocalizedValue(benefit.title) ?? '',
      description: useLocalizedValue(benefit.description) ?? '',
      icon: benefit.icon,
    })),
  }
}
